module.exports = __webpack_public_path__ + "img/End_train.e1e3feb3.png";